const sizes = {
    S: 's',
    L: 'l',
};

export default sizes;
